import React, { useState, useEffect, useRef } from "react";
import { ZoomIn, ZoomOut, RotateCcw } from "lucide-react";
import condicaoComercialImg from "../../assets/images/CondicaoC.jpg";
import { checkAuth, handleAuthError } from "../../utils/auth";

const CondicaoComercialViewer = () => {
  const [scale, setScale] = useState(0.6);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const containerRef = useRef(null);

  useEffect(() => {
    if (!checkAuth()) {
      window.location.href = "/login";
      return;
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (scale === 0.6) {
      setPosition({ x: 0, y: 0 });
    }
  }, [scale]);

  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.1, 3));
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.1, 0.3));
  };

  const handleReset = () => {
    setScale(0.6);
    setPosition({ x: 0, y: 0 });
  };

  const handleMouseDown = (e) => {
    if (scale > 0.6) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && scale > 0.6) {
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;

      setPosition({
        x: newX,
        y: newY,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    if (scale > 0.6) {
      setIsDragging(true);
      setDragStart({
        x: e.touches[0].clientX - position.x,
        y: e.touches[0].clientY - position.y,
      });
    }
  };

  const handleTouchMove = (e) => {
    if (isDragging && scale > 0.6) {
      const newX = e.touches[0].clientX - dragStart.x;
      const newY = e.touches[0].clientY - dragStart.y;

      setPosition({
        x: newX,
        y: newY,
      });
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className="container mx-auto flex flex-col items-center p-4">
      <h1 className="text-2xl font-bold mb-4 text-center">
        Condição Comercial Vigente
      </h1>

      <div className="flex space-x-2 mb-4 justify-center">
        <button
          onClick={handleZoomIn}
          className="p-2 rounded-full bg-red-500 text-white hover:bg-red-600 focus:outline-none"
          title="Ampliar"
        >
          <ZoomIn size={20} />
        </button>
        <button
          onClick={handleZoomOut}
          className="p-2 rounded-full bg-red-500 text-white hover:bg-red-600 focus:outline-none"
          title="Reduzir"
        >
          <ZoomOut size={20} />
        </button>
        <button
          onClick={handleReset}
          className="p-2 rounded-full bg-gray-500 text-white hover:bg-gray-600 focus:outline-none"
          title="Redefinir"
        >
          <RotateCcw size={20} />
        </button>
      </div>

      <div
        ref={containerRef}
        className="w-full overflow-auto border border-gray-300 rounded-lg bg-white flex justify-center items-start"
        style={{ maxHeight: "calc(100vh - 200px)" }}
      >
        <div
          className="relative flex justify-center items-center"
          style={{
            cursor: isDragging ? "grabbing" : scale > 0.6 ? "grab" : "default",
          }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <img
            src={condicaoComercialImg}
            alt="Condição Comercial"
            style={{
              transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
              transformOrigin: "center",
              transition: isDragging ? "none" : "transform 0.2s ease",
            }}
            className="max-w-full h-auto"
            draggable="false"
          />
        </div>
      </div>

      {scale > 0.6 && (
        <div className="text-center text-sm text-gray-500 mt-2">
          {isMobile
            ? "Arraste para mover a imagem"
            : "Clique e arraste para mover a imagem"}
        </div>
      )}
    </div>
  );
};

export default CondicaoComercialViewer;
